import React, {FunctionComponent, lazy, useState} from "react";
import {makeStyles} from "tss-react/mui";
import moment from "moment/moment";
import {Theme} from "@mui/material";
import {useAppDispatch, useAppSelector} from "@/Redux/Redux";
import {useDrop} from "react-dnd";
import {OPEN_VEHICLE_INFO,} from "@/Redux/Disposition/Constants";
import ForeignStation from "@/Domains/DispositionManagement/Components/DispositionBody/Elements/ForeignStation";
import VehiclePopover from "@/Domains/DispositionManagement/Components/Popovers/VehiclePopover";
import VehicleAvailability from "@/Domains/DispositionManagement/Components/DispositionBody/Elements/VehicleAvailability";
import BookingLine from "@/Domains/DispositionManagement/Components/DispositionBody/Elements/BookingLine";
import {useConfirm} from "material-ui-confirm";
import {useSelector} from "react-redux";
import {selectMandant, selectParameters,} from "@/Redux/App/AppReducer";
import {logger} from "@/Logger";
import NewBookingPopup from "@/Domains/DispositionManagement/Components/Modals/NewBookingPopup";
import {selectViewerEnabledStations, ViewerState,} from "@/Redux/Auth/AuthReducer";
import Common from "@/Utils/Common";
import {useTranslation} from "@/Utils/CustomHooks/useTranslation";
//import BookingOverlayWrapper from "../../../../BookingManagement/Booking/Shared/Containers/BookingOverlayWrapper";
const BookingOverlayWrapper = lazy(
    () =>
        import(
            "../../../../BookingManagement/Booking/Shared/Containers/BookingOverlayWrapper"
            )
);

interface VehicleLineProps {
    lineItem: any;
    contentWidth: number | undefined;
    dateTimeDictionary?: any | null;
    dateTimeDictionaryOneDay?: any | null;
    viewData?: any;
}

const useStyles = makeStyles()((theme: Theme) => ({
    vehicleInfoWrapper: {
        fontSize: 12,
        background: "rgba(242,242,242)",
        width: 206,
        float: "left",
        marginBottom: 4,
        height: 52,
        overflow: "hidden",
        display: "flex",
        paddingLeft: 15,
        paddingRight: 15,
        cursor: "pointer",
        color: "#000",
    },
    info: {
        wordBreak: "break-all",
        fontSize: 11,
        paddingTop: 6,
        lineHeight: 1.1,
        flex: "1 1",
    },
    licensePlate: {
        display: "block",
        padding: 2,
        backgroundColor: "#fff",
        border: "1px solid #5c5c5c",
        borderLeft: "5px solid blue",
        borderRadius: 4,
        fontSize: 11,
        lineHeight: "12px",
        fontWeight: 700,
        marginBottom: 2,
    },
    extras: {
        paddingTop: 10,
        paddingLeft: 8,
        paddingRight: 8,
        flex: "1 1",
    },
    extrasIcon: {
        marginRight: 5,
        marginBottom: 8,
        display: "inline-flex",
        fontSize: 14,
    },
    groupInfo: {
        flex: "1 1",
        textAlign: "right",
        display: "flex",
        justifyContent: "flex-end",
        paddingTop: 8,
    },
    vehicleRow: {
        marginBottom: 2,
        height: 54,
        borderBottom: "1px solid #000000",
    },
    popover: {
        pointerEvents: "none",
    },
    paper: {
        padding: theme.spacing(1),
    },
    appBar: {
        position: "relative",
        boxShadow: "none",
    },
    title: {
        flex: 1,
    },
}));

const VehicleLine: FunctionComponent<VehicleLineProps> = ({
                                                              lineItem,
                                                              contentWidth,
                                                              dateTimeDictionary,
                                                              dateTimeDictionaryOneDay,
                                                              viewData
                                                          }): JSX.Element => {
    const {classes, cx} = useStyles();
    const {dispositionStartdate, dispositionEnddate, stationFilter} =
        useAppSelector((state) => state.disposition);
    const mandant = useSelector((state) => selectMandant(state));
    const [popoverPositionX, setPopoverPositionX] = React.useState<number>(0);
    const [popoverPositionY, setPopoverPositionY] = React.useState<number>(0);
    const [popoverIsOpen, setPopoverIsOpen] = React.useState<boolean>(false);
    const dispatch = useAppDispatch();
    const allowedDropEffect = "any";
    const confirm = useConfirm();
    const {t} = useTranslation();
    const [lastClickXPos, setLastClickXPos] = React.useState<number>(0);
    const [bookingViewIsOpen, setBookingViewIsOpen] =
        React.useState<boolean>(false);
    const [newBookingPopupIsOpen, setNewBookingPopupIsOpen] =
        React.useState<boolean>(false);
    const [newBookingType, setNewBookingType] = useState<string | null>(null);
    const [newBookingAction, setNewBookingAction] = useState<string | null>(
        null
    );
    const enabledStations = useSelector((state) =>
        selectViewerEnabledStations(state as ViewerState)
    );
    const newBookingAllowed =
        enabledStations.filter(
            (station: any) =>
                station.isChangeableInDispo == "J" &&
                station.stationId === lineItem.location.stationId
        ).length > 0;
    const parameter = useSelector((state) => selectParameters(state));

    // @ts-ignore
    const conflictBookings = [];

    const {days, dayWidth} = useAppSelector((state) => state.disposition);

    const renderNewBookingPopup = () => {
        if (!newBookingPopupIsOpen) {
            return <></>;
        }

        let clickedDate = dispositionStartdate;

        // @ts-ignore
        const a =
            lastClickXPos -
            (window.innerWidth -
                parseInt(document.getElementById("dispo_content").style.width) *
                (dayWidth / 100) *
                days);
        let b = 0;
        let i = 1;

        if (days === 1) {
            // @ts-ignore
            const c =
                lastClickXPos -
                (window.innerWidth -
                    parseInt(
                        document.getElementById("dispo_content").style.width
                    ) *
                    (dayWidth / 100) *
                    24);

            // @ts-ignore
            const x =
                c %
                (parseInt(
                        document.getElementById("dispo_content").style.width
                    ) *
                    (dayWidth / 100));

            // @ts-ignore
            while (
                c >=
                parseInt(document.getElementById("dispo_content").style.width) *
                (dayWidth / 100) *
                i
                ) {
                i++;
                b++;
            }

            // @ts-ignore
            const closest = Object.keys(dateTimeDictionaryOneDay).reduce(
                (prev, curr) => {
                    // @ts-ignore
                    return Math.abs(curr - x) < Math.abs(prev - x)
                        ? curr
                        : prev;
                }
            );

            const [hours, minutes] =
                dateTimeDictionaryOneDay[closest].split(":");

            clickedDate = moment(clickedDate).toDate();
            clickedDate.setHours(parseInt(hours) + b + 1, parseInt(minutes));
        } else {
            // @ts-ignore
            const x =
                a %
                (parseInt(
                        document.getElementById("dispo_content").style.width
                    ) *
                    (dayWidth / 100));

            // @ts-ignore
            while (
                a >=
                parseInt(document.getElementById("dispo_content").style.width) *
                (dayWidth / 100) *
                i
                ) {
                i++;
                b++;
            }

            clickedDate = moment(clickedDate).add(b, "d").toDate();

            // @ts-ignore
            const closest = Object.keys(dateTimeDictionary).reduce(
                (prev, curr) => {
                    // @ts-ignore
                    return Math.abs(curr - x) < Math.abs(prev - x)
                        ? curr
                        : prev;
                }
            );

            const [hours, minutes] = dateTimeDictionary[closest].split(":");

            clickedDate.setHours(parseInt(hours) + 2, parseInt(minutes));
        }

        return (
            <NewBookingPopup
                handleClose={() => {
                    setNewBookingPopupIsOpen(false);
                }}
                predefinedStartdate={moment(clickedDate).format(
                    "YYYY-MM-DDTHH:mm"
                )}
                predefinedVehicleId={lineItem.vehicleId}
                predefinedStartstationId={lineItem.location.stationId}
                predefinedVehicleGroupId={lineItem.vehicleGroup.vehicleGroupId}
                viewData={viewData}
            />
        );
    };

    const detectReservation = (reservation: any) => {
        let success = false;
        conflictBookings.length = 0;

        const dropVehicle = lineItem;
        const dropVehicleRes = lineItem.reservations;
        const thisStartDate = moment.utc(reservation.startdate);
        const thisEndDate = moment.utc(reservation.plannedEnddate);
        const availableFrom = moment.utc(dropVehicle.availableFrom);
        const availableUntil = moment.utc(dropVehicle.availableUntil);

        if (
            [1, "1"].indexOf(
                parameter.data.find(
                    (param: any) => param.parameter === "BDISPO_NO_MOVE_AUSST"
                )?.value
            ) !== -1
        ) {
            if (
                thisStartDate.isBefore(availableFrom) ||
                thisEndDate.isAfter(availableUntil)
            ) {
                success = true;
            }
        }

        for (const reservationKey in dropVehicleRes) {
            const res = dropVehicleRes[reservationKey];

            const startDate = moment.utc(res.startdate);
            let endDate = null;
            if (res.enddate) {
                endDate = moment.utc(res.enddate);
            } else {
                endDate = moment.utc(res.plannedEnddate);
            }
            if (
                startDate.isBefore(thisEndDate) &&
                endDate.isAfter(thisStartDate)
            ) {
                conflictBookings.push({
                    id: res.bookingId,
                    vehicleId: lineItem.vehicleId,
                    station: res?.startstation?.stationId || res.startstation,
                });
                if (mandant.abasId === 70447) {
                    success = !res.isDraggable;
                } else {
                    success = true;
                }
            }

            if (res.bookingId === reservation.bookingId) {
                success = false;
            }
        }

        return success;
    };

    const [{canDrop, isOver}, drop] = useDrop(
        () => ({
            accept: "booking",
            drop: () => ({
                type: "vehicle",
                destination: {
                    vehicleId: lineItem.vehicleId,
                    stationId: null,
                    // @ts-ignore
                    conflictBookings: conflictBookings.length
                        ? conflictBookings
                        : null,
                    bookingId: lineItem.bookingId,
                },
                allowedDropEffect,
            }),
            canDrop: (item, monitor) => {
                // @ts-ignore
                return !detectReservation(item.booking);
            },
            collect: (monitor) => {
                return {
                    canDrop: monitor.getItem() === null || monitor.canDrop(),
                    isOver: monitor.isOver(),
                };
            },
        }),
        [allowedDropEffect]
    );

    const handlePopoverOpen = (
        event: React.MouseEvent<HTMLElement, MouseEvent>
    ) => {
        function isTouchDevice() {
            return "ontouchstart" in window || navigator.maxTouchPoints > 0;
        }

        if (isTouchDevice()) {
            return;
        }
        setPopoverPositionX(event.clientX);
        setPopoverPositionY(event.clientY);
        setPopoverIsOpen(true);
    };

    const handlePopoverClose = () => {
        setPopoverIsOpen(false);
    };

    let myExtras = [];
    if (lineItem.equipment !== null) {
        myExtras = lineItem.equipment.split(",");
    }

    return (
        <>
            {renderNewBookingPopup()}
            {!canDrop && (
                <div
                    className={classes.vehicleInfoWrapper}
                    style={{
                        background: "rgba(255,0,0,0.5)",
                        width: "100%",
                        position: "absolute",
                        zIndex: 51,
                    }}
                />
            )}
            <div
                className={classes.vehicleInfoWrapper}
                //className={this.props.toggledCars.indexOf(this.props.stationId) >= 0 ? "vehicle__info collapse" : "vehicle__info"}
                onMouseMove={handlePopoverOpen}
                data-testid={"clickVehicleLine-" + lineItem?.vehicleId}
                onMouseLeave={handlePopoverClose}
                onClick={(e) => {
                    logger.log(
                        "user clicked openVehicleInfo for vehicle " +
                        lineItem.vehicleId
                    );
                    dispatch({
                        type: OPEN_VEHICLE_INFO,
                        data: {item: lineItem},
                    });
                }}
                style={{
                    background: lineItem.dispoColor,
                    width: "306px",
                    float: "left",
                }}
                data-searchresult={lineItem.isSearchResult}
            >
                <div className={classes.info}>
                    {Common.findAndParseFieldActions(viewData?.FieldActionList?.actions ?? [], "licensePlate")?.visible !== false && (<span className={classes.licensePlate}>
                        {lineItem.licensePlate}
                    </span>)}
                    {lineItem.name}
                </div>
                <div className={classes.extras}>
                    {myExtras.map((extra: string) => (
                        <span
                            key={
                                "vehicleLineExtras-" +
                                lineItem.vehicleId +
                                "-" +
                                extra
                            }
                            className={cx(
                                classes.extrasIcon,
                                "cx9_fzga_ico cx9-" + extra
                            )}
                        />
                    ))}
                </div>
                <div className={classes.groupInfo}>
                    <p style={{marginBottom: "1rem", marginTop: 0}}>
                        <span style={{display: "block", marginBottom: 4}}>
                            <b>{lineItem.vehicleGroup.vehicleGroupId}</b>
                        </span>
                        {lineItem.mileage} / {lineItem.maximumMileage}
                    </p>
                </div>
            </div>
            <div
                className={cx(classes.vehicleRow, "vehicle__row")}
                data-id={lineItem.vehicleId}
                data-testid={"vehicleLineRow-" + lineItem?.vehicleId}
                ref={drop}
                onClick={(event) => {
                    if (!newBookingAllowed || mandant.abasId == 70447) {
                        return;
                    }
                    logger.log(
                        "user clicked free space on vehicle line for vehicle " +
                        lineItem.vehicleId
                    );
                    setLastClickXPos(event.clientX);
                    setNewBookingPopupIsOpen(true);
                }}
                data-station={lineItem.location.stationId}
                style={{
                    width: "calc(100%-306px)",
                    paddingLeft: "306px",
                }}
            >
                {moment
                    .utc(lineItem.availableFrom)
                    .isSameOrAfter(moment.utc(dispositionStartdate)) && (
                    <VehicleAvailability
                        startdate={dispositionStartdate}
                        enddate={lineItem.availableFrom}
                        contentWidth={contentWidth}
                        type={"active"}
                    />
                )}

                {Object.keys(lineItem.reservations).map((contractId) => {
                    const reservation = lineItem.reservations[contractId];

                    return (
                        <React.Fragment
                            key={"foreignStation-" + reservation.bookingId}
                        >
                            {reservation.startstation &&
                                (reservation?.startstation?.stationId
                                    ? reservation?.startstation?.stationId
                                    : reservation?.startstation) !==
                                lineItem.location.stationId && (
                                    <ForeignStation
                                        reservationToCompareWith={reservation}
                                        reservations={lineItem.reservations}
                                        startForeign={true}
                                        contentWidth={contentWidth}
                                    />
                                )}
                            <BookingLine
                                lineItem={reservation}
                                setDragDropClass={false}
                                contentWidth={contentWidth}
                                viewData={viewData}
                            />
                            {((reservation.enddate &&
                                    reservation.endstation &&
                                    (reservation?.endstation?.stationId ? reservation?.endstation?.stationId : reservation?.endstation) !==
                                    lineItem.location.stationId) ||
                                (reservation.plannedEndstation &&
                                    (reservation?.plannedEndstation?.stationId ? reservation?.plannedEndstation?.stationId : reservation?.plannedEndstation) !==
                                    lineItem.location.stationId)) && (
                                <ForeignStation
                                    reservationToCompareWith={reservation}
                                    reservations={lineItem.reservations}
                                    startForeign={false}
                                    contentWidth={contentWidth}
                                />
                            )}

                        </React.Fragment>
                    );
                })}

                {moment
                    .utc(lineItem.availableUntil)
                    .isSameOrBefore(moment.utc(dispositionEnddate)) && (
                    <VehicleAvailability
                        startdate={lineItem.availableUntil}
                        enddate={dispositionEnddate}
                        contentWidth={contentWidth}
                        type={"inactive"}
                    />
                )}
            </div>
            {popoverIsOpen && (
                <VehiclePopover
                    lineItem={lineItem}
                    popoverPositionX={popoverPositionX}
                    popoverPositionY={popoverPositionY}
                    open={popoverIsOpen}
                    handlePopoverClose={handlePopoverClose}
                />
            )}
        </>
    );
};

export default React.memo(VehicleLine);
